import script from "./GlobalVideoSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalVideoSettings.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__